import { render, staticRenderFns } from "./ElManage.vue?vue&type=template&id=d6cfc976&scoped=true"
import script from "./ElManage.vue?vue&type=script&lang=js"
export * from "./ElManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6cfc976",
  null
  
)

export default component.exports